import { Link } from "react-router-dom-v5-compat";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";

import styles from "./OfferEligibleBanner.module.scss";

export interface OfferEligibleBannerProps {
  searchAllStaysHref: string;
  onSearchAllStays?: () => void;
  className?: string;
}

export const OfferEligibleBanner = ({
  searchAllStaysHref,
  onSearchAllStays,
  className,
}: OfferEligibleBannerProps) => {
  const [block, cn] = useModuleBEM(styles, "OfferEligibleBanner");
  const { t } = useI18nContext();

  return (
    <div className={clsx(block, className)} role="note">
      <Icon iconName={IconNameEnum.priceTag} className={cn("icon")} />
      <div className={cn("content")}>
        <p className={cn("body")}>{t("hotelFundedOffersPage.banner.body")}</p>
        <Link
          to={searchAllStaysHref}
          className={cn("cta")}
          onClick={onSearchAllStays}
        >
          {t("hotelFundedOffersPage.banner.cta")}
        </Link>
      </div>
    </div>
  );
};
